<template>
    <div class="page">
        <div class="cyclework_body">

            <div class="top_label">
                <span class="lable_name">
                    布置周期作业
                </span>
                <el-button @click="$router.back(-1)" type="text" icon="el-icon-arrow-left" size="medium">返回</el-button>
            </div>




            <form class="cyclework_form" :model="form_data">
                <div class="title">
                    <i class="el-icon-edit"></i>
                    <span class="lable_name">作业名称</span>
                </div>
                <div>
                    
                    <span><el-input v-model="form_data.title" placeholder="请输入作业名称"></el-input></span>
                </div>
                <div class="title" style="margin-top:20px">
                    <i class="el-icon-setting"></i>
                    <span class="lable_name">阅读在线设置</span>
                </div>
                <div class="top_label_type">
                    <div style="display: inline-block;width: 100%;">

                        <div style="clear: both;"></div>
                        <div v-for="(city,index) in cities" :key="index" style="margin-bottom: 10px;">
                            <span :class="`read_label`">{{city.name}}</span>
                            <el-select v-model="read_grade[index]" placeholder="请选择题型">
                                <el-option
                                
                                v-for="(item_,index_) in city.type"
                                
                                :key="index_"
                                :label="item_"
                                :value="index_">
                                </el-option>
                            </el-select>
                            <el-input prefix-icon="el-icon-edit" v-model="form_data.read_type[index]" placeholder="输入篇数"></el-input>
                        </div>
                        
                    </div>
                    
                </div>
                <div class="title">
                    <i class="el-icon-setting"></i>
                    <span class="lable_name">应试英语设置</span>
                </div>
                <div class="top_label_type">
                    <div>
                        <div style="clear: both;"></div>
                        <div v-for="(city,index) in cispace_data" :key="index" style="margin-bottom: 10px;">
                            <span class="specialty_label" >{{city.name}}</span>
                            <!-- <el-select v-model="specialty_grade[index]" v-if="city.type" placeholder="请选择难度">
                                <el-option
                                
                                v-for="(city_item,city_index) in city.type"
                                
                                :key="city_index"
                                :label="city_item"
                                :value="city_item">
                                </el-option>
                            </el-select> -->
                            <el-input v-if="city.pid != 0" prefix-icon="el-icon-edit" v-model="form_data.specialty_type[city.id]" placeholder="输入篇数"></el-input>
                        </div>
                    </div>
                </div>
                <div class="title">
                    <i class="el-icon-setting"></i>
                    <span class="lable_name">推送设置</span>
                </div>
    
                <div v-if="plan.length > 1" class="top_label_type" style="margin-bottom: 20px;line-height: 30px;">
                    <div class="rands_box">
                        <el-button size="small" type="primary">试题随机</el-button>
                        <el-checkbox style="margin-left:15px" border size="small" v-model="form_data.rands">每个班级是否推送相同试题</el-checkbox>
                    </div>
                </div>
                <div class="top_label_type" style="margin-bottom: 20px;">
                    <div>
                        <!-- <el-tooltip class="item" effect="dark" content="" placement="top-start"> -->
                            <el-button size="small" type="primary">作业周期</el-button>
                        <!-- </el-tooltip> -->
                        
                        <el-date-picker
                            v-model="form_data.time"
                            type="daterange"
                            align="right"
                            size="small"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                        <el-tooltip class="item" effect="dark" content="按周或按月布置作业选择的时间区间最后一个周期如果不足一周或者一月则不会计算，比如：1日到20日，二月时间不足一月，则只会生成一个周期" placement="right">
                            <i style="margin-top: 7px;font-size: 20px;margin-left: 10px;color: #409EFF;" class="el-icon-question"></i>
                        </el-tooltip>
                        
                    </div>
                </div>
                <div class="top_label_type" style="margin-bottom: 20px;line-height: 33px;">
                    <div class="top_label_period">
                        <el-button size="small" type="primary">推送周期</el-button>
                        <el-radio-group v-model="form_data.period">
                            <el-radio border size="small" :label="1">周</el-radio>
                            <el-radio border size="small" :label="2">月</el-radio>
                            <el-radio border size="small" :label="3">学期</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="title">
                    <i class="el-icon-monitor"></i>
                    <span class="lable_name">推送班级</span>
                </div>

                <div class="top_label_type" style="margin-bottom: 20px;">
                    <div>
                        <el-checkbox-group v-model="form_data.plan" size="small">
                            <el-checkbox v-for="(item,index) in plan" :key="index" :value="item.id" :label="item.id" border>{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    
                </div>
            </form>

            <el-button :loading="loading" size="small" @click="submitForm" type="primary">设置完成，确认布置作业</el-button>
        
        </div>
    </div>
</template>
<script>
import Http from "../../apis/work";
export default {
    data(){
        return{
            loading:false,
            form_data:{
                read_type:[],
                specialty_type:[],
                period:1,
                plan:[],
                rands:'',
                time:null,
                title:''
            },
            specialty_grade:{},
            read_grade:{},
            cities:{
                1:{
                    name:'一级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
                2:{
                    name:'二级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
                3:{
                    name:'三级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
                4:{
                    name:'四级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
                5:{
                    name:'五级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
                6:{
                    name:'六级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
                7:{
                    name:'七级',
                    type:['随机题型','选择题','判断题','匹配题'],
                },
            },
            cispace_data: [],
            input:'',
            checked:true,
            value2:'',
            radio:1,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            plan:[],
            work_data:[],
            cispace_data_type:{
                7:["A卷","B卷"],
                9:["A卷","B卷"],
                14:["四级","六级"],
                19:["专业四级","专业八级"]
            }
        }
    },

    created(){
        this.read_grade = {}
        this.specialty_grade = {}
        // this.form_data = {
        //         read_type:[],
        //         specialty_type:[],
        //         period:1,
        //         plan:[],  // 这里应该是数组，不是字符串
        //         rands:'',
        //         time:null,
        //         title:''
        //     },

        //this.form_data.plan = this.$route.query.plan
        this.getCollection_()
        this.getPlan_()
    },

    methods:{

        // 获取应试题型
        getCollection_(){
            Http.getCollection_().then((res) => {
                var data = res.data
                var result = {};
                // for (const [key, value] of Object.entries(data)) {
              
                //     result[key] = {
                //         name: value,
                //         type: this.cispace_data_type[key]
                //     };
                // }

                this.cispace_data = data
            });
        },

        // 获取班级名称

        getPlan_(plan){
            var params = {}
            params.plan = plan
            Http.getPlanName(params).then((res) => {
                this.plan = res.data

            });
        },
        
        // 确认布置
        submitForm(){
            //this.loading = true
            var params = JSON.parse(JSON.stringify(this.form_data))

            
            if(params.read_type){
                var read_data = this.initialize(params.read_type)
                params.read_type = read_data.type.join(',')
                params.read_number = read_data.number.join(',')
                if(params.read_type.split(',')[0]){
                    if(params.read_type.split(',').length != Object.keys(this.read_grade).length){
                        this.$message({
                            message: '请检查信息填写是否有误',
                            type: 'error'
                        });
                        return false;
                    }
                }
                
            }
            if(params.specialty_type){
                var specialty_data = this.initialize(params.specialty_type)
                params.specialty_type = specialty_data.type.join(',')
                params.specialty_number = specialty_data.number.join(',')
            }

            if (!params.read_number.length && !params.specialty_number.length) {  
                this.$message({
                    message: '请任意选择一种类型作业',
                    type: 'error'
                });
                return false
            }

            if (!params.time) {  
                this.$message({
                    message: '请选择作业时间周期',
                    type: 'error'
                });
                return false
            }

            const loading = this.$loading({
                lock: true,
                text: '正在布置作业，请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.3)'
            });

            params.specialty_grade = this.specialty_grade
            params.read_grade = this.read_grade
            params['start_time'] = this.$Common.getTime(params.time[0])
            params['end_time'] = this.$Common.getTime(params.time[1])
            params['rands'] = params.rands?1:0
            delete params.time;
            params.plan = params.plan.join(',')
            
            Http.createCyclework(params).then((res) => {
                this.loading = false
                setTimeout(()=>{
                    loading.close()
                },1000)
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.code ? 'success' : 'error'
                });
                if(res.code){
                    // 重置表单
                    this.form_data = {
                        read_type:[],
                        specialty_type:[],
                        period:1,
                        plan:[],
                        rands:'',
                        time:null,
                        title:''
                    }
                    this.$router.back(-1)
                    
                }
            });

        },


        initialize(data){

            var type = [];
            var number = [];
            var result = {}
            for(var index in data){

                if(data[index]){
                    type.push(index)
                    number.push(data[index])
                }
            }
            result.type = type
            result.number = number
            return result;
        }


    }

}
</script>

<style scoped>
.cyclework_body{
    display: inline-block;
    width: 100%;
}

.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-bottom: 25px;
}
.lable_name{
    font-size: 16px;
    font-weight: bold;
}

.cyclework_form{
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-bottom: 25px;
    padding: 20px;
    text-align: left;
}

.cyclework_form .title{
    margin-bottom: 15px;
}

.cyclework_form .title i{
    margin-right: 5px;
}

.top_label_period{
    display: flex;
    align-items: center;
}


.lable_name >>> .el-breadcrumb{
    font-size: 16px;
}
.top_label >>> .el-input{
    width: 20vw;
    float: left;
}
.rands_box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;
}

.top_label_type >>>.el-checkbox-group{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    flex-wrap: wrap;
    align-items: center;
    gap: 15px;
}

.top_label_type >>> .el-checkbox{
    margin-right: 0px !important;
    margin-left: 0px !important;
}


.top_label_type div{
    text-align: left;
}
.top_label_type div >>> .el-button{
    float: left;
}
.top_label_type{
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
}
.top_label_type >>> .el-input{
    width: 12vw;
    margin-left: 10px;
    margin-right: 15px;
}
.top_label_type >>> .el-checkbox-group{
    text-align: left;
    margin-top: 10px;
}
.top_label_type >>> .el-date-editor{
    float: left;
    margin-left: 15px;
}
.top_label_type >>> .el-radio-group{
    margin-left: 15px;
}
.top_label_type >>> .el-tag{
    margin-right: 12px;
}
.read_label{
    padding: 11px 20px;
    border: 1px solid #DCDFE6;
    font-size: 12px;
    margin-right: 10px;
    border-radius: 5px;
    background: #f5f5f5;
}
.specialty_label{
    display: inline-block;
    padding: 11px 20px;
    border: 1px solid #DCDFE6;
    font-size: 12px;
    margin-right: 10px;
    border-radius: 5px;
    width: 180px;
    text-align: center;
    background: #f5f5f5;
}
.active{
    background-color: #409EFF !important;
    border-color: #409EFF !important;
    color: #ffffff !important;
}
</style>
